import {ComponentsConfigs} from '@gongxigames/framework/core/types/systemComponentsTypes';
import {modules} from '@gongxigames/framework/slotV2/ui/ui-koala/modules';

export const koalaUIComponentsConfig: ComponentsConfigs = {
    modules: [
        ...modules,
    ]
};